import $ from 'jquery';

$(function() {
    const $serviceList = $('.user-service-list');
    const $serviceSelector = $('.user-service-selector');

    if ($serviceList.length && $serviceSelector.length) {

        const $serviceCategories = $serviceSelector.find('.user-service-cat-select');
        const $serviceSelect = $serviceSelector.find('.user-service-select');
        const $services = $serviceSelector.find('.user-service-select option');
        const $addService = $serviceSelector.find('input[type="submit"]');
        const $updateButton = $serviceList.siblings('input[type="submit"]');
        let $newService = null;

        function disableClick($element) {
            $element.addClass('disabled');
            $element.attr('disabled', 'disabled');
        }

        function enableClick($element) {
            $element.removeClass('disabled');
            $element.removeAttr('disabled');
        }

        disableClick($addService);
        disableClick($updateButton);


        // Update service when category changes
        $serviceCategories.change(function(e) {
            const catId = $(e.target).val();

            $services.removeClass('active');
            $services.each(function() {
                const $this = $(this);
                if ( $this.data('serviceCatId') == catId ) {
                    $this.addClass('active');
                }
            });
        });

        // Get the new service information when it changes
        $serviceSelect.change(function(e) {
            $newService = $(e.target).find(":selected");
            enableClick($addService);
        });

        // handle adding the service
        $addService.on('click', function() {
            if ($serviceList.find('input[value="' + $newService.val() + '"]').length) {
                alert("You already have that service, please select another.");
            } else {
                let $elem = $(
                    '<div class="user-service">' +
                    '<input type="hidden" name="fields[userServiceType][]" value="' + $newService.val() + '">' +
                    '<div class="service-name">' + $newService.data('serviceName') + '</div>' +
                    '<div class="service-cat">' + $newService.data('serviceCat') + '</div>' +
                    '<a href="" class="service-remove">Remove</a>' +
                    '</div>');
                $serviceList.append($elem);
                enableClick($updateButton);
            }

            return false;
        });

        $serviceList.on('click', '.service-remove', function(e) {
            $(e.target).parent('.user-service').remove();
            enableClick($updateButton);
            return false; // Stop propogation and default event
        });
    }
});
